import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { apiFetch } from '../../utils/api';
import Spinner from '../../components/Spinner/Spinner';
import BlogCard from '../../components/BlogCard/BlogCard';
import '../CatalogCategoryPage/CatalogCategoryPage.css';
import '../CartPage/CartPage.css';
import './BlogPage.css';

const BlogPage = () => {
  const { t, i18n } = useTranslation();
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      setPosts(null);
      const res = await apiFetch('/api/public/blog', {
        headers: { Locale: i18n.language },
      });
      setPosts(res.ok ? await res.json() : []);
    };
    fetchPosts();
  }, [i18n.language]);

  if (!posts) return <Spinner />;

  const [latest, ...older] = posts;

  return (
    <div className="catalog-page blog-page">
      <div className="blog-page-header">
        <h1>{t('blog.title')}</h1>
        <p className="blog-page-subtitle">{t('blog.subtitle')}</p>
      </div>

      {!latest ? (
        <div className="cart-empty">
          <span className="material-symbols-outlined cart-empty-icon">article</span>
          <p className="cart-empty-text">{t('blog.empty')}</p>
        </div>
      ) : (
        <>
          <BlogCard post={latest} featured />
          {older.length > 0 && (
            <ul className="blog-grid">
              {older.map(post => (
                <li key={post._id}>
                  <BlogCard post={post} />
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
};

export default BlogPage;
